'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ScrollModel = require('../models/ScrollModel');
const BaseCarousel = require('../base/BaseCarousel');
const classnames = require('classnames');


/**
 * Represents a carousel with that a user scrolls through horizontally.
 * @class
 */
class ScrollCarousel extends React.Component {
    componentWillMount() {
        this._model = new ScrollModel({
            itemsPerPage: this.props.itemsPerPage
        });

        // Dummy state. State is held in the `_model` but this is necessary to force a re-render when the model
        // updates.
        this.state = {
            modelState: this._model.getState()
        };
    }

    render() {
        const {list, item} = this.props.classNames;

        const listClass = classnames({
            ['scroll-carousel-list']: true,
            [list]: list
        });
        const itemClass = classnames({
            ['scroll-carousel-item']: true,
            [item]: item
        });

        return (
            <div className="scroll-carousel-wrapper">
                <BaseCarousel model={this._model} classNames={{list: listClass, item: itemClass}}>
                    {this.props.children}
                </BaseCarousel>
            </div>
        );
    }
}

ScrollCarousel.propTypes = {
    // Items to display per "page". This indicates the number of items that should be visible at once. One of the
    // items will be pushed partially off-page to indicate to the user that the list is scrollable.
    itemsPerPage: PropTypes.number,
    classNames: PropTypes.object,
    children: PropTypes.node
};

ScrollCarousel.defaultProps = {
    itemsPerPage: 2,
    classNames: {}
};

module.exports = ScrollCarousel;



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/views/ScrollCarousel.jsx